import api from "@/api";
import BatterTableDataView from "@/components/BatterTableDataView.vue";
import ButtonDialog from "@/components/ButtonDialog.vue";
export default {
  name: "BannerConfigView",
  components: {
    ButtonDialog,
    BatterTableDataView
  },
  data() {
    return {
      tab: '-',
      sites: []
    };
  },
  methods: {
    fetchAllData() {
      for (let r of this.$refs.bannerTable) {
        r.fetchData();
      }
    },
    changeEnableState(id, e) {
      api.updateBannerEnableState(id, e).then(() => {
        this.fetchAllData();
      });
    },
    init() {
      api.getEnumOptionList(4, true).then(ret => {
        this.sites = ret;
        this.tab = ret.length > 0 ? ret[0].label : '-';
      });
    }
  },
  mounted() {
    this.init();
  }
};